// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__XxnKD","paginationItem":"Pagination_paginationItem__Bn9Ek","active":"Pagination_active__lYljq"};